'use client'

import { useMemo, useState } from 'react'

import Button from 'shared/ui/Button'

import DiscountCodeCard from '../../submodules/discountCodes/components/DiscountCodeCard'
import {
  DiscountCode,
  DiscountCodeCartValue
} from '../../submodules/discountCodes/types'
import {
  checkValidCode,
  filterDiscountCodes,
  sortDiscountCodes
} from '../../submodules/discountCodes/utils'
import { filtersData } from '../../utils'

import styles from './ProfileBenefitCodes.module.scss'

const ProfileBenefitCodes = ({
  discountCodes,
  cart
}: {
  discountCodes: DiscountCode[]
  cart: DiscountCodeCartValue | null
}) => {
  const [activeCategory, setActiveCategory] = useState('all')

  const sortedAndFilteredRebateCodes = useMemo(() => {
    const sortedRebateCodes = sortDiscountCodes(discountCodes, cart)

    return filterDiscountCodes(sortedRebateCodes, cart, activeCategory)
  }, [discountCodes, cart, activeCategory])

  return (
    <>
      <div className={styles.header}>
        <div className={styles.title} id='profile_details_delivery_addresses'>
          Kody rabatowe
        </div>
      </div>
      <div className={styles.filterWrapper}>
        {filtersData.map(filter => (
          <Button
            key={filter.id}
            onClick={() => setActiveCategory(filter.id)}
            variant='neutralOutline'
            active={filter.id === activeCategory}
          >
            <p className={styles.filterName}>{filter.name}</p>
          </Button>
        ))}
      </div>
      <ul className={styles.rebateCodesWrapper}>
        {sortedAndFilteredRebateCodes.map(rebate => {
          const {
            isCodeAvailable,
            isCodeUsed,
            marketingNotConsent,
            minimumOrderValueNotAchieved
          } = checkValidCode(rebate, cart)

          return (
            <li className={styles.listItem} key={rebate.id}>
              <DiscountCodeCard
                rebate={rebate}
                isCodeAvailable={isCodeAvailable}
                isCodeUsed={isCodeUsed}
                marketingNotConsent={marketingNotConsent}
                minimumOrderValueNotAchieved={minimumOrderValueNotAchieved}
              />
            </li>
          )
        })}
      </ul>
      {sortedAndFilteredRebateCodes.length === 0 && (
        <div className={styles.emptyState}>
          <h3 className={styles.emptyStateTitle}>
            Brak wybranych kodów rabatowych.
          </h3>
        </div>
      )}
    </>
  )
}

export default ProfileBenefitCodes
